/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormModel } from '../../models/form-model';

export interface FormsIdGet$Params {
  id: string;
}

export function formsIdGet(http: HttpClient, rootUrl: string, params: FormsIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<FormModel>> {
  const rb = new RequestBuilder(rootUrl, formsIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<FormModel>;
    })
  );
}

formsIdGet.PATH = '/Forms/{id}';
